module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user != '') ? _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLHeader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage-head-image",
    staticStyle: {
      "background-image": "url('assets/img/subpage-head.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n        HATÁR Adminisztráció\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("HATÁR Adminisztráció kliens program")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "assets/files/HatarKliens.application"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n          Letöltés (Windows)\n        ")])]), _vm._v(" "), _c('h4', [_vm._v("Telepítéshez szükséges összetevők")]), _vm._v(" "), _c('small', [_c('ul', [_c('li', [_c('a', [_vm._v("Windows Installer 4.5")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v(".NET Framework 3.5 SP1")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Microsoft Data Access Components 2.8")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("SAP Crystal Reports Runtime Engine for .NET Framework")])])])]), _vm._v(" "), _c('h4', [_vm._v("Hibaelhárítás")]), _vm._v(" "), _c('small', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('strong', [_vm._v("Hiba")]), _c('br'), _vm._v("\n            \"Az alkalmazást nem lehet telepíteni vagy futtatni, mert ehhez előbb telepíteni kell a globális szerelvény-gyorsítótárban (GAC) a(z) CrystalDecisions.ReportAppServer.CommonObjectMode I - verzió 13.0.2000.0 szerelvényt.\"\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('strong', [_vm._v("Megoldás")]), _c('br'), _vm._v("\n            A következő két fájlt töltsd le és telepítsd őket:\n            "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "assets/files/CRRuntime_32bit_13_0_4.msi",
      "target": "_blank"
    }
  }, [_vm._v("CRRuntime_32bit_13_0_4.msi")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "assets/files/CRRuntime_64bit_13_0_4.msi",
      "target": "_blank"
    }
  }, [_vm._v("CRRuntime_64bit_13_0_4.msi")])])]), _vm._v("\n            Ezután próbáld meg újra a HATÁR telepítést.\n          ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e9e151c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/hatar_admin.vue
// module id = 324
// module chunks = 0